/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
// import { authenticateSettings } from 'components/helper/appConfig';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { appMenuGroups, toolsAnalyticGroups, icons } from 'router/router';
import { useHistory, useLocation } from 'react-router';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getHousehold } from 'app/family/familySlice';
import { getGeneral } from 'app/testingSlice/testingSlice';
// import { routers } from 'router/router';
import { getUserId, getAccessToken } from 'utils/sessionStorage';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { usePageStatus } from 'hooks/usePageStatus';
import { PAGE_NAME } from 'constants/common';

// Menu for Student only
export default function NestedList() {
  const dispatch = useAppDispatch();
  let history = useHistory();
  let location = useLocation();
  const [checkModuleState, setCheckModuleState] = useState<any>(null);
  const [roleFamilyState, setRoleFamilyState] = useState<any>(null);
  const [roleTestState, setRoleTestState] = useState<any>(null);
  const roleFamily = useAppSelector((store) => store.family?.roleFamily);
  const roleTest = useAppSelector((store) => store.testing.roleTest);
  const checkModule = useAppSelector((store) => store.basicInformation.checkModule);
  const [open, setOpen] = React.useState<string | null>(null);
  // const [completedPages, setCompletedPages] = useState<Set<string>>(new Set());
  
  let studentId = getUserId();
  let token = getAccessToken();
  
  // Use the custom hook for page status
  const { pageStatus } = usePageStatus({ studentId: studentId || '' });

  useEffect(() => {
    try {
      appMenuGroups.forEach((route: any) => {
        if (
          route.children.find((e: any) => location?.pathname?.includes(e?.path?.replace('/:id', '')))
        ) {
          setOpen(route.name);
        }
      });
  
      toolsAnalyticGroups.forEach((route: any) => {
        if (
          route.children.find((e: any) => location?.pathname?.includes(e?.path?.replace('/:id', '')))
        ) {
          setOpen(route.name);
        }
      });
    }
    catch(ex){
      console.log('Error:', ex);
    }

  }, [location]);


  const handleClick = (route: any) => {
    if (open === route.name) return setOpen(null);
    setOpen(route.name);
    if (route.isGroup === false) {
      history.push(route.route.path);
    }
  };

  React.useEffect(() => {
    setRoleFamilyState(roleFamily);
  }, [roleFamily]);

  React.useEffect(() => {
    setRoleTestState(roleTest);
  }, [roleTest]);

  React.useEffect(() => {
    async function getData() {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        try {
          setCheckModuleState(checkModule);

          await dispatch(getHousehold(studentId)).unwrap();
          await dispatch(getGeneral(studentId)).unwrap();
        } catch (ex) {
          // Backend will handle invalid tokens, no need to auto logout
          console.error('Error getting data:', ex);
        }
      }
      // If no token/userId, just skip - backend will handle authentication
    }
    getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkModule]);

  function filteredKeys_removeItem(filteredKeys: string[], keyVal: string) {
    var index = filteredKeys.findIndex((e: string) => e === keyVal);
    if (index > -1) {
      filteredKeys.splice(index, 1);
    }
  }

  function filteredKeys_checkRoleTest(filteredKeys: string[], roleTest: any) {
    if (roleTest) {
      if (roleTest?.satTest === false) {
        filteredKeys_removeItem(filteredKeys, '4.1'); // SAT Tests
      }
      if (roleTest?.actTest === false) {
        filteredKeys_removeItem(filteredKeys, '4.2'); // ACT Tests
      }
      if (roleTest?.actSubjectTest === false) {
        filteredKeys_removeItem(filteredKeys, '4.3'); // AP Subject Tests
      }
      if (roleTest?.ibSubjectTest === false) {
        filteredKeys_removeItem(filteredKeys, '4.4'); // IB Subject Tests
      }
      if (roleTest?.clepTest === false) {
        filteredKeys_removeItem(filteredKeys, '4.5'); // CLEP Tests
      }
      if (roleTest?.toeflTest === false) {
        filteredKeys_removeItem(filteredKeys, '4.6'); //  TOEFL iBT
      }
      if (roleTest?.ieltsAndPte === false) {
        filteredKeys_removeItem(filteredKeys, '4.7'); //  PTE Academic && IELTS
      }
      if (roleTest?.douLingoTest === false) {
        filteredKeys_removeItem(filteredKeys, '4.8'); //  DuoLingo
      }
    }
  }

  const getChildPageStatus = (child: any) => {
    if (child?.name === 'Citizenship/Residency') {
      return pageStatus.find((status: any) => status.page_name === 'Citizenship-Residency');
    }
    if (child?.name === 'General Info' && child?.path === '/application/general-info') {
      return pageStatus.find((status: any) => status.page_name === 'Test General Info');
    }
    return pageStatus.find((status: any) => status.page_name === child?.name);
  };

  const isChildVisible = (child: any) => {
    const disabled =
      child.permission &&
      !{ ...roleFamilyState, ...roleTestState }[child.permission];
    return !disabled;
  };

  const getTestRequiredPages = () => {
    const requiredPages = [PAGE_NAME.GENERAL_TEST];

    if (roleTestState?.satTest) {
      requiredPages.push(PAGE_NAME.SAT_TEST);
    }
    if (roleTestState?.actTest) {
      requiredPages.push(PAGE_NAME.ACT_TEST);
    }
    if (roleTestState?.actSubjectTest) {
      requiredPages.push(PAGE_NAME.ACT_SUBJECT_TEST);
    }
    if (roleTestState?.ibSubjectTest) {
      requiredPages.push(PAGE_NAME.IB_SUBJECT_TEST);
    }
    if (roleTestState?.clepTest) {
      requiredPages.push(PAGE_NAME.CLEP_TEST);
    }

    return requiredPages;
  };

  const getParentCompletion = (route: any) => {
    if (route?.name === 'Tests') {
      const requiredPages = getTestRequiredPages();
      if (requiredPages.length === 0) {
        return { hasAny: false, allStudent: false, allCounselor: false };
      }

      const statuses = requiredPages
        .map((pageName) => pageStatus.find((status: any) => status.page_name === pageName))
        .filter(Boolean);

      const allStudent =
        statuses.length === requiredPages.length &&
        statuses.every((status: any) => status.student_completed);

      const allCounselor =
        statuses.length === requiredPages.length &&
        statuses.every((status: any) => status.counselor_verified);

      return { hasAny: true, allStudent, allCounselor };
    }

    if (route?.name === 'Summary') {
      const summaryStatuses = (route?.children || [])
        .map(getSummaryChildCompletion)
        .filter(Boolean);

      if (summaryStatuses.length === 0) {
        return { hasAny: false, allStudent: false, allCounselor: false };
      }

      const allStudent = summaryStatuses.every(
        (status: any) => status.studentCompleted
      );
      const allCounselor = summaryStatuses.every(
        (status: any) => status.counselorCompleted
      );

      return { hasAny: true, allStudent, allCounselor };
    }

    const visibleChildren = route?.children?.filter(isChildVisible) || [];
    if (visibleChildren.length === 0) {
      return { hasAny: false, allStudent: false, allCounselor: false };
    }
    const statuses = visibleChildren
      .map(getChildPageStatus)
      .filter(Boolean);

    const allStudent =
      statuses.length === visibleChildren.length &&
      statuses.every((status: any) => status.student_completed);

    const allCounselor =
      statuses.length === visibleChildren.length &&
      statuses.every((status: any) => status.counselor_verified);

    return { hasAny: true, allStudent, allCounselor };
  };

  const getAdditionalInfoCompletion = () => {
    const studentCompleted = !!pageStatus.find(
      (status: any) => status.page_name === PAGE_NAME.ADDITIONAL_INFO
    )?.student_completed;

    const counselorCompleted =
      !!pageStatus.find(
        (status: any) => status.page_name === PAGE_NAME.ADDITIONAL_INFO_1
      )?.counselor_verified &&
      !!pageStatus.find(
        (status: any) => status.page_name === PAGE_NAME.ADDITIONAL_INFO_2
      )?.counselor_verified &&
      !!pageStatus.find(
        (status: any) => status.page_name === PAGE_NAME.ADDITIONAL_INFO_3
      )?.counselor_verified;

    return { studentCompleted, counselorCompleted };
  };

  const getSummaryChildCompletion = (child: any) => {
    if (child?.name === PAGE_NAME.ADDITIONAL_INFO) {
      return getAdditionalInfoCompletion();
    }

    const matchingGroup = appMenuGroups.find(
      (group: any) => group?.isGroup && group?.name === child?.name
    );
    if (!matchingGroup) return null;

    const parentCompletion = getParentCompletion(matchingGroup);
    return parentCompletion.hasAny
      ? {
          studentCompleted: parentCompletion.allStudent,
          counselorCompleted: parentCompletion.allCounselor,
        }
      : null;
  };

  return (
    <List
      sx={{
        width: '100%',
        maxWidth: 360,
        bgcolor: 'background.paper',
        height: '100%',
        overflow: 'auto',
      }}
      component="nav"
      subheader={
        <ListSubheader component="div" className="text-field-light text-center">
          {/* All changes saved <SaveOutlinedIcon fontSize="small" /> */}
        </ListSubheader>
      }
    >
      {appMenuGroups.map((route: any, index: any) => {
        const IconBefore = icons[route.icon] || 'Component';
        return (
          <div key={index}>
            <ListItemButton
              onClick={() => handleClick(route)}
              className={`px-1 my-1 ${open === route.name && 'bg-light fw-bold'}`}
            >
              <IconBefore fontSize="small" className="me-2 text-secondary" />
              <span className="text-field-mid">{route.name}</span>

              {route.name === PAGE_NAME.ADDITIONAL_INFO && (
                <span className="ms-auto d-flex align-items-center gap-1">
                  {getAdditionalInfoCompletion().studentCompleted && <img
                    alt="csu"
                    src="./assets/icons/tick-blue.svg"
                    style={{ marginTop: '-8px', marginLeft: '4px' }}
                  />}
                  {getAdditionalInfoCompletion().counselorCompleted && <img
                    alt="counselor-approved"
                    src="./assets/icons/tick-green.svg"
                    style={{ marginTop: '-8px', marginLeft: '4px' }}
                  />}
                </span>
              )}
              {route.isGroup && route.name !== PAGE_NAME.ADDITIONAL_INFO && (() => {
                const parentCompletion = getParentCompletion(route);
                return parentCompletion.hasAny && (
                  <span className="ms-auto d-flex align-items-center gap-1">
                    {parentCompletion.allStudent && (
                      <img
                        alt="csu"
                        src="./assets/icons/tick-blue.svg"
                        style={{ marginTop: '-8px', marginLeft: '4px' }}
                      />
                    )}
                    {parentCompletion.allCounselor && (
                      <img
                        alt="counselor-approved"
                        src="./assets/icons/tick-green.svg"
                        style={{ marginTop: '-8px', marginLeft: '4px' }}
                      />
                    )}
                  </span>
                );
              })()}
              {route.isGroup &&
                (open === route.name ? (
                  <ExpandLess fontSize="small" className="text-field-light" />
                ) : (
                  <ExpandMore fontSize="small" className="text-field-light" />
                ))}
            </ListItemButton>
            {route.isGroup && (
              <Collapse in={open === route.name} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {route.children.map((child: any, i: number) => {
                    let module = '';
                    switch (child?.name) {
                      case 'Personal':
                        module = '1.';
                        break;
                      case 'Family':
                        module = '2.';
                        break;
                      case 'Education':
                        module = '3.';
                        break;
                      case 'Tests':
                        module = '4.';
                        break;
                      case 'Courses & Grades':
                        module = '5.';
                        break;
                      case 'Activities & Honors':
                        module = '6.';
                        break;
                      case 'Additional Info':
                        module = '7.';
                        break;
                      case 'GPA Forecaster':
                        module = '9.';
                        break;
                      default:
                        break;
                    }

                    let filteredKeys = checkModuleState
                      ? Object.keys(checkModuleState).filter((key) => key.startsWith(`${module}`))
                      : [];

                    // remove hiding role Test tab
                    filteredKeys_checkRoleTest(filteredKeys, roleTestState);

                    if (!roleFamilyState?.siblings && filteredKeys.length > 0) {
                      const index = filteredKeys.indexOf('2.4');
                      if (index > -1) {
                        filteredKeys.splice(index, 1);
                      }
                    }

                    if (
                      !roleFamilyState?.stepParent1 &&
                      !roleFamilyState?.stepParent2 &&
                      filteredKeys.length > 0
                    ) {
                      const index = filteredKeys.indexOf('2.5');
                      if (index > -1) {
                        filteredKeys.splice(index, 1);
                      }
                    }

                    // const allTrue =
                    //   filteredKeys.length > 0 &&
                    //   filteredKeys.every((key) => checkModuleState[key][0] === true);

                    // const allCounselorTrue =
                    //   filteredKeys.length > 0 &&
                    //   filteredKeys.every((key) => checkModuleState[key][1] === true);

                    const disabled =
                      child.permission &&
                      !{ ...roleFamilyState, ...roleTestState }[child.permission];

                    return disabled ? null : (
                      <ListItemButton
                        key={i}
                        sx={{ pl: 2, pt: 2 }}
                        onClick={() => history.push(child?.path.replace(':id', studentId))}
                        disabled={disabled}
                      >
                        <span className="text-secondary">{child?.icon}</span>
                        <span
                          className={
                            location.pathname.includes(child?.path.replace(':id', ''))
                              ? 'text-primary fw-bold'
                              : 'text-field-mid'
                          }
                        >
                          {child?.name}
                        </span>

                        {
                          // Check if this page is completed based on pageStatus
                          (() => {
                            const summaryCompletion =
                              route.name === 'Summary'
                                ? getSummaryChildCompletion(child)
                                : null;

                            const currentStatus = summaryCompletion
                              ? null
                              : getChildPageStatus(child);

                            const studentCompleted = summaryCompletion
                              ? summaryCompletion.studentCompleted
                              : currentStatus?.student_completed;

                            const counselorCompleted = summaryCompletion
                              ? summaryCompletion.counselorCompleted
                              : currentStatus?.counselor_verified;

                            return (studentCompleted || counselorCompleted) && (
                              <span className="ms-auto d-flex align-items-center gap-1">
                                {studentCompleted && (
                                  <img
                                    alt="csu"
                                    src="./assets/icons/tick-blue.svg"
                                    style={{ marginTop: '-8px', marginLeft: '4px' }}
                                  />
                                )}

                                {counselorCompleted && (
                                  <img
                                    alt="counselor-approved"
                                    src="./assets/icons/tick-green.svg"
                                    style={{ marginTop: '-8px', marginLeft: '4px' }}
                                  />
                                )}
                              </span>
                            );
                          })()
                        }
                        {/* 
                        {[
                          'Personal',
                          'Family',
                          'Education',
                          'Tests',
                          'Courses & Grades',
                          'Activities & Honors',
                          'Additional Info',
                          'GPA Forecaster'
                        ].includes(child?.name) && (
                          <span className="ms-auto">
                            {allTrue && (
                              <img
                                alt="csu"
                                src="./assets/icons/tick-blue.svg"
                                style={{ marginTop: '-8px', marginLeft: '4px' }}
                              />
                            )}
                            {allCounselorTrue && (
                              <img
                                alt="csu"
                                src="./assets/icons/tick-green.svg"
                                style={{ marginTop: '-8px', marginLeft: '4px' }}
                              />
                            )}
                            {completedPages.has(child?.name) && (
                              <CheckCircleIcon 
                                fontSize="small" 
                                style={{ 
                                  marginTop: '-8px', 
                                  marginLeft: '4px',
                                  color: '#28a745'
                                }} 
                              />
                            )}
                          </span>
                        )} */}
                      </ListItemButton>
                    );
                  })}
                </List>
              </Collapse>
            )}
          </div>
        );
      })}
    </List>
  );
}
